// ------------------------------------------------------------------------------
// UserRender
// author: mudas
// created: 2025/7/24
// ------------------------------------------------------------------------------

import React, { FC, PropsWithChildren } from 'react';

import { UserDefaultAvatar } from 'common/constants';
import { Avatar, AvatarProps, Typography } from '@fuxi/eevee-ui';

export interface IProps {
  className?: string;
  data?: Record<string, any>;
  avatarOptions?: AvatarProps;

  fieldNames?: {
    key?: string;
    nickName?: string;
    avatar?: string;
  };
}

const UserRender: FC<PropsWithChildren<IProps>> = (props) => {
  const { className, data, avatarOptions, fieldNames, children } = props;

  const { key: fieldKey, nickName: fieldNickName, avatar: fieldAvatar } = fieldNames || {};
  const key = fieldKey ? data?.[fieldKey] : data?.uniqueId || data?.mediaUserId || data?.userCode;
  const nickName = fieldNickName
    ? data?.[fieldNickName]
    : data?.nickName || data?.mediaNickname || (!!data?.userCode ? `创作者${data.userCode}` : '');
  const avatar = fieldAvatar ? data?.[fieldAvatar] : data?.avatar || UserDefaultAvatar;

  return (
    <div key={key} className={`grid grid-cols-[max-content_1fr_max-content] items-center gap-2 ${className}`}>
      <Avatar size={32} src={avatar} {...avatarOptions} />
      <Typography.Text ellipsis={{ tooltip: nickName }}>{nickName}</Typography.Text>

      {children && (
        <div className="ml-4 flex gap-2" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      )}
    </div>
  );
};

export default UserRender;
